<script>
import CommonTableComponent from "@/components/table";
import pagination from "@/mixins/pagination";
import tableHeaders from "@/configs/tableHeaders";
import tableSearch from "@/mixins/tableSearch";
import ListReservationIsWorkOrderRequest from "@/views/pages/project/schedule/reservation/list_reservation_is_work_order_request"
import ListReservationIsNotWorkOrderRequest from "@/views/pages/project/schedule/reservation/list_reservation_is_not_work_order_request"

export default {
  props: ['visible'],
  components: {
    CommonTableComponent,
    ListReservationIsWorkOrderRequest,
    ListReservationIsNotWorkOrderRequest,
  },
  mixins: [pagination, tableSearch],
  data() {
    return {
      btnTabOptions: [
        {
          text: '配車課',
          value: ['01', '02', '03', '05', '06', '07']
        },
        {
          text: '環境管理部',
          value: ['04', '05', '07']
        },
        {
          text: '積替保管',
          value: ['06']
        },
      ],
      indexTab: 0,
    }
  },
  methods: {
    changeTab(index) {
      this.indexTab = index
    },
  },
  computed: {
    workOrderTypeArr() {
      return this.btnTabOptions[this.indexTab]?.value
    },
    visibleProp() {
      return this.visible
    }
  }
}
</script>

<template>
  <div>
    <div class="d-flex btn-group">
      <template v-for="(option,index) in btnTabOptions">
        <input type="radio"
              class="btn-check"
              :id="`btnTab${index}`"
              :checked="index === indexTab"
        >
        <label class="btn"
              :class="index === indexTab ? 'btn-primary' : 'btn-outline-primary'"
              :for="`btnTab${index}`" @click="changeTab(index)"
        >
          {{ option.text }}
        </label>
      </template>
    </div>
    <ListReservationIsWorkOrderRequest :workOrderTypeArr="workOrderTypeArr" :tabIndex="{tabIndex: indexTab}"/>
    <ListReservationIsNotWorkOrderRequest :workOrderTypeArr="workOrderTypeArr" :tabIndex="{tabIndex: indexTab}"/>
  </div>

</template>

